import ProductCard from "./ProductCard";

const products = [
  {
    id: 1001,
    name: "Ladies Fancy Rimless Sunglasses With Gradient Lenses - Gold Frame / Black Lens",
    price: 750,
    image: "/image/shop/SunglassesRimless.jpeg",
  },
  {
    id: 1002,
    name: "HX-T90 Ultra Bright Rechargeable LED Headlight – Multi-Mode Waterproof Headlamp with Magnetic Function & Type-C Fast Charging",
    price: 950 ,
    image: "/image/shop/Bright Rechargeable LED.png",
  },
  {
    id: 1003,
    name: "DIGITAL HANGING SCALE 50kg ABS LCD Display Strap Travel Multifunctional Digital Luggage Weighing Scales",
    price: 800,
    image: "/image/shop/Digital wighting scales.jpg",
  },
  {
    id: 1004,
    name: "WAGLOK Slim Tuck Lock Wallet with ID Window & Cash Pocket - Brown",
    price: 300,
    image: "/image/shop/Slim Tuck Lock Wallet.png",
  },
  {
    id: 1005,
    name: "7.5% nHAP White Tooth Repair Hydroxyapatite Toothpaste – Advanced Enamel Whitening & Stain Reduction (120g)",
    price: 350,
    image: "/image/shop/White Tooth Repair.png",
  },
  // Add other products...
];

export default function ProductGrid() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          id={product.id}
          image={product.image}
          name={product.name}
          price={product.price}
          description={product.description}
        />
      ))}
    </div>
  );
}